(function (angular) {
    angular
        .module('harriApp')
        .controller('gpMultipleApplyModal', [
            '$scope', '$state', 'modalData', 'JobDetailsBus', '$filter', 'hUser', '$modal', 'Upload', 'googleMaps', 'jobApplyFactory',
            'positionsDataService', '$q', 'registrationApi', 'localize', 'httpHelper', 'hEvent', 'googleSearchService',
            function ($scope, $state, modalData, JobDetailsBus, $filter, hUser, $modal, Upload, googleMaps, jobApplyFactory,
                      positionsDataService, $q, registrationApi, localize, httpHelper, hEvent, googleSearchService) {

                var MULIPLE_APPLY_STEPS = [
                    {
                        code: 'SELECT_JOBS',
                        label: 'Select Jobs',
                    }, {
                        code: 'JOBS_APPLICATION',
                        label: 'Jobs Application',
                    },
                ];

                const MASSACHUSETTS_STATE_NAME = 'Massachusetts';

                $scope.modalData = modalData;
                $scope.jobs = modalData.jobs;
                $scope.allJobsIds = $scope.jobs && _.pluck($scope.jobs, 'id');
                $scope.currentStep = MULIPLE_APPLY_STEPS[0].code;
                $scope.steps = [];
                $scope.steps = MULIPLE_APPLY_STEPS;
                var applicantFirstName = modalData.applicantFirstName;
                var applicantLastName = modalData.applicantLastName;
                var referrer = modalData.referrer;
                var resetPasswordCode = modalData.resetPasswordCode;
                var showLogin = modalData.showLogin;
                var APPLY_MODAL_SELECTOR = "#job_apply_modal";
                $scope.disableApply = false;
                $scope.saving = false;
                $scope.loading = true;

                $scope.trackEvent = function (eventName, data, callback) {
                    data = data || {};

                    var analyticsData = $.extend({
                        category: 'job_apply'
                    }, data);

                    hEvent.track(eventName, analyticsData, callback);
                };

                var checkUser = function () {
                    var deferred = $q.defer();
                    if (hUser.isLoggedIn()) {
                        jobApplyFactory.getCandidateApplyStatus($scope.modalData.brand.id).then(()=>{
                            if (!hUser.data.user.email) {
                                $scope.userHasNoEmail = true;
                                $scope.addEmailForm = new AddEmailForm($scope);
                                $scope.addEmailForm.visible = true;

                                $scope.submitEmail = () => {
                                    $scope.isPending = true;
                                    $scope.addEmailForm.validator.validate((isValid) => {
                                        if (isValid) {
                                            $scope.addEmailForm.save()
                                                .then(() => {
                                                    $scope.addEmailForm.visible = false;
                                                    delete $scope.addEmailForm;
                                                    deferred.resolve()
                                                })
                                                .catch((err) => {
                                                    console.error('err', err);
                                                })
                                                .finally(() => {
                                                    $scope.isPending = false;
                                                });
                                        }
                                        else {
                                            $scope.isPending = false;
                                            deferred.resolve()
                                        }
                                    });
                                }
                            } else {
                                deferred.resolve()
                            }
                        }).catch((error)=>{
                            if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                hAlert(
                                    $filter("translate")("Error"),
                                    jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                    () => {
                                        $scope.$hide();
                                        $scope.saving = false;
                                    }
                                );
                            }
                        })
                    }
                    else {
                        var userLoggedInBefore = HStorageManager.get({
                            key: 'is_user',
                            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                        });
                        var servicesToCheck = ['GDPR', 'NO_PASSWORD_QUICK_APPLY', 'E_VERIFY'];
                        JobApplicationAPI.checkServicesOnJobs($scope.allJobsIds, servicesToCheck)
                            .then(function (res) {
                                $scope.existingServices = res['existing_services'];
                                var quickApplyService = $scope.existingServices.find(function (e) {
                                    return (e.code == 'NO_PASSWORD_QUICK_APPLY');
                                });
                                var isQuickApplyEnabled = (quickApplyService) ? true : false;
                                var everifyService = $scope.existingServices.map(function (e) {
                                    return (e.code)
                                }).indexOf('E_VERIFY');
                                $scope.everifyServiceEnabled = (everifyService > -1) ? true : false;
                                var GDPRService = $scope.existingServices.map(function (e) {
                                    return (e.code)
                                }).indexOf('GDPR');
                                var isGDPREnabled = (GDPRService > -1) ? true : false;
                                $scope.signUpForm = new SignUpForm($scope, hUser, isQuickApplyEnabled ? quickApplyService.brands[0] : null , null, localize, httpHelper, referrer, 'MULTIPLE_APPLY');
                                $scope.signUpSocialLinksForm = new SignUpSocialLinksForm($scope, hUser, isQuickApplyEnabled ? quickApplyService.brands[0] : null , null, localize, httpHelper, referrer);
                                $scope.signUpForm.setSource('qr');
                                $scope.signUpForm.setFirstName(applicantFirstName);
                                $scope.signUpForm.setLastName(applicantLastName);
                                $scope.signUpForm.showGDPRDisclaimer(isGDPREnabled);
                                $scope.signUpForm.setQuickApplyStatus(isQuickApplyEnabled);
                                if (userLoggedInBefore || resetPasswordCode || showLogin) {
                                    $scope.loginFormVisible = true;
                                }
                                else if (!showLogin){
                                    $scope.signUpForm.visible = true;
                                }

                                if ($scope.signUpForm.visible && showLogin) {
                                    setTimeout(function () {
                                        $('.login-options').find('button')[0].focus();
                                    }, 600);
                                }

                                $scope.goToSignUp = function () {
                                    delete $scope.loginFormVisible;
                                    $scope.signUpForm.visible = true;
                                    $(APPLY_MODAL_SELECTOR).scrollTop(0);
                                    setTimeout(function () {
                                        $('.login-options').find('button')[0].focus();
                                    },200);
                                };

                                $scope.handleLogin = function(userData) {
                                    hUser.getFullUserData().then(function () {
                                        hUser.login();
                                        formsSavedCallback();
                                    });
                                }

                                $scope.onCustomChallenge = function(challenge) {
                                    if(challenge) {
                                        $scope.isCredentialled = true;
                                        $scope.$digest();
                                    }
                                }

                                $scope.signUpForm.goToLogin = function () {
                                    delete $scope.signUpForm.visible;
                                    $scope.loginFormVisible = true;
                                    $(APPLY_MODAL_SELECTOR).scrollTop(0);
                                };

                                var socialLoginHandler = $scope.$on('logged-in-from-oauth', function (event, provider, userData) {
                                    hUser.login(userData);
                                    HStorageManager.remove({
                                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                        key: 'placeholder_token'
                                    });
                                    // Unsubscribe to social login event
                                    socialLoginHandler();

                                    if (!$scope.expressIsSubmitting) {
                                        $scope.loginFormVisible = false;
                                        delete $scope.signUpForm;
                                    }

                                    if (hUser.isLoggedIn()) {
                                        jobApplyFactory.getCandidateApplyStatus($scope.modalData.brand.id).then(()=>{
                                            $scope.selectJobsForm.load($scope.modalData);
                                        }).catch((error)=>{
                                            if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                                hAlert(
                                                    $filter("translate")("Error"),
                                                    jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                                    () => {
                                                        $scope.$hide();
                                                        $scope.saving = false;
                                                    }
                                                );
                                            }
                                        })
                                    }

                                    setTimeout(function () {
                                        $scope.$digest();
                                    }, 1);

                                    // Track login to analytics
                                    $scope.trackEvent('user_login', {
                                        'label': provider
                                    });
                                });

                                var formsSavedCallback = function () {
                                    var type =  $scope.loginFormVisible? 'LOGIN': 'REGISTER';

                                    if (resetPasswordCode) {
                                        $state.go('.', { code: null }, false);
                                        type = 'PASSWORD_RESET';
                                    }

                                    if (!$scope.expressIsSubmitting) {
                                        $scope.loginFormVisible = false;
                                        delete $scope.signUpForm;
                                    }

                                    $scope.trackEvent('user_login', {
                                        'label': type
                                    });

                                    jobApplyFactory.getCandidateApplyStatus($scope.modalData.brand.id).then(() => {
                                        $scope.selectJobsForm.load($scope.modalData);

                                        setTimeout(() => {
                                            $scope.$digest();
                                        }, 1);
                                    }).catch((error) => {
                                        if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                            hAlert(
                                                $filter("translate")("Error"),
                                                jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                                () => {
                                                    $scope.$hide();
                                                    $scope.saving = false;
                                                }
                                            );
                                        }
                                    });
                                };

                                $scope.signUpForm.onFormSaved(formsSavedCallback);
                                $scope.$digest();
                                deferred.resolve()
                            })
                            .catch(function (err) {
                                console.error(err);
                                deferred.reject();
                            });
                    }

                    return deferred.promise;
                };
                checkUser()
                    .then(function () {
                        $scope.multipleApplyWizardForm = new MultipleApplyWizardForm($scope);
                        $scope.selectJobsForm = new SelectJobsForm($scope, JobDetailsBus, $filter);
                        $scope.multipleApplyWizardForm.load({activeStep: $scope.currentStep, steps: $scope.steps});
                        if (hUser.isLoggedIn() || ($scope.signUpForm && !$scope.signUpForm.visible && !$scope.loginFormVisible)) {
                            $scope.selectJobsForm.load($scope.modalData);
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                    })
                    .finally(function () {
                        $scope.saving = false;
                        $scope.loading = false;
                    });

                var onRemoveJob = function (formId, appliedJobIds) {
                    $modal({
                        controller: 'removeJobModal',
                        templateUrl: '../modules/profiles/modals/remove-job/remove-job.modal.html',
                        show: true,
                        resolve: {
                            modalData: function () {
                                return {
                                    jobsName: getJobsName(appliedJobIds),
                                };
                            },
                            onSave: function () {
                                return function () {
                                    var jobApplicationForms = $scope.jobApplicationForms.getForms();
                                    var eeoScreeningForms = $scope.eeoScreeningForms.getForms();

                                    for (var k in appliedJobIds) {
                                        var jobIndex = $scope.selectedJobs.findIndex(function (job) {
                                            return (job.id === appliedJobIds[k]);
                                        });

                                        if (jobIndex > -1) {
                                            $scope.selectedJobs.splice(jobIndex, 1);
                                        }

                                        var formIndex = $scope.applicationForms['SCREENING_FORM'].findIndex(function (screening_form) {
                                            return (screening_form.id == formId
                                                || (screening_form.appliedJobIds.toString() === [appliedJobIds[k]].toString()));
                                        });
                                        if (formIndex > -1) {
                                            $scope.applicationForms['SCREENING_FORM'][formIndex].hidden = true;

                                        }

                                        for (var i in jobApplicationForms) {
                                            if (jobApplicationForms[i].id && (formId === jobApplicationForms[i].id)
                                                || (jobApplicationForms[i].appliedJobIds && jobApplicationForms[i].appliedJobIds.toString() === [appliedJobIds[k]].toString())) {
                                                $scope.jobApplicationForms.deleteForm(jobApplicationForms[i]);
                                            }
                                        }

                                        if ($scope.applicationForms['EEO_SCREENING_FORM']){
                                            var formIndexEEO = $scope.applicationForms['EEO_SCREENING_FORM'].findIndex(function (eeo_screening_form) {
                                                return (eeo_screening_form.id == formId
                                                    || (eeo_screening_form.appliedJobIds.toString() === [appliedJobIds[k]].toString()));
                                            });
                                            if (formIndexEEO > -1) {
                                                $scope.applicationForms['EEO_SCREENING_FORM'][formIndexEEO].hidden = true;
                                            }

                                            for (var j in eeoScreeningForms) {
                                                if (eeoScreeningForms[j].id && (formId === eeoScreeningForms[j].id)
                                                    || (eeoScreeningForms[j].appliedJobIds.toString() === [appliedJobIds[k]].toString())) {
                                                    $scope.eeoScreeningForms.deleteForm(eeoScreeningForms[j]);
                                                }
                                            }

                                            if (eeoScreeningForms.length == 0){
                                                $scope.applicationDetails.eeo_screening_forms = null;
                                                $scope.eeoScreeningForms = new FormGroup();
                                                var filteredSteps = MULIPLE_APPLY_STEPS.filter(function (step) {
                                                    return (step.code !== 'EEO_SCREENING_QUESTIONS');
                                                });
                                                MULIPLE_APPLY_STEPS = filteredSteps;
                                                $scope.steps = MULIPLE_APPLY_STEPS;
                                                $scope.multipleApplyWizardForm.load({
                                                    activeStep: $scope.currentStep,
                                                    steps: $scope.steps
                                                });
                                            }
                                        }

                                        if ($scope.applicationForms['DISCLAIMERS']){
                                            var clearedDisclaimers = $scope.applicationForms['DISCLAIMERS'].disclaimers.filter(function (disclaimer_form) {
                                                return (disclaimer_form.applied_job_ids.toString() !== [appliedJobIds[k]].toString());
                                            });
                                            $scope.applicationForms['DISCLAIMERS'].disclaimers = clearedDisclaimers || [];
                                            if ($scope.applicationForms['DISCLAIMERS'].disclaimers.length == 0){
                                                $scope.applicationDetails.disclaimers = null;
                                                $scope.disclaimerForms = new FormGroup();
                                                var filteredSteps = MULIPLE_APPLY_STEPS.filter(function (step) {
                                                    return (step.code !== 'DISCLAIMERS');
                                                });
                                                MULIPLE_APPLY_STEPS = filteredSteps;
                                                $scope.steps = MULIPLE_APPLY_STEPS;
                                                $scope.multipleApplyWizardForm.load({
                                                    activeStep: $scope.currentStep,
                                                    steps: $scope.steps
                                                });
                                            }
                                        }
                                    }
                                    $scope.jobsIds = _.pluck($scope.selectedJobs, 'id');
                                    $scope.numsOfSelectedJobs = $scope.selectedJobs.length;

                                    if ($scope.selectedJobs.length == 0){
                                        $scope.$hide();
                                    }
                                };
                            }
                        }
                    });
                };

                var onDisclaimerCheckboxChange = function (disclaimer_consent) {
                    if (disclaimer_consent) {
                        $scope.disableApply = false;
                    } else {
                        $scope.disableApply = true;
                    }
                };

                var prepareApplicationForms = function () {
                    $scope.formsToFill.forEach(function (options) {
                        var formOptions = options;
                        var formCode = formOptions.code;
                        var form = null;
                        switch (formCode) {
                            case 'PHONE':
                                form = new BasicInfoForm($scope, hUser);
                                form.templateURL = "../modules/hforms/basic_info/views/basic_info_form.html";
                                form.viewTitle = $filter("translate")("User information");
                                form.formCode = "PHONE";
                                break;
                            case 'AVAILABILITY_MATRIX':
                                form = new AvailabilityMatrixForm($scope);
                                form.templateURL = "../modules/hforms/availability_matrix/views/availability_matrix_form.html";
                                form.viewTitle = $filter("translate")("What days of the week are you able to commit to") + "?";
                                form.load($scope.applicationDetails.availability_matrix);
                                form.formCode = "availability_matrix";
                                break;
                            case 'RESUME':
                                form = new ResumeUploadForm($scope, Upload, null, hUser, $scope.selectedJobs, true, $scope.applicationDetails.user_location);
                                form.setRequired(!formOptions.is_optional);
                                form.allowParse(false);
                                form.templateURL = "../modules/hforms/resume_upload/views/resume_upload_form.html";
                                form.formCode = "resume_url";
                                break;
                            case 'WORK_HISTORY':
                                form = new ExperienceForm($scope, hUser.getUser().id, googleMaps, positionsDataService);
                                form.templateURL = "../modules/hforms/experience/views/experience_form.html";
                                form.viewTitle = $filter("translate")("Work experience");
                                form.type = form.TYPES.JOB_APPLICATION;
                                form.formCode = "WORK_HISTORY";
                                break;
                            case 'WORK_ELIGIBILITY':
                                form = new WorkEligibilityForm($scope, $scope.applicationDetails.work_eligibility_groups[0].options);
                                form.templateURL = "../modules/hforms/work_eligibility/views/work_eligibility_form.html";
                                form.viewTitle = $filter("translate")("Are you eligible to work in the UK and able to provide ‘right to work’ documents?");
                                form.formCode = "work_eligibility";
                                break;
                            case 'EDUCATION':
                                form = new EducationForm($scope, hUser.getUser().id, googleMaps);
                                form.setIsEducationDatesMandatoryFlag($scope.isEducationDatesMandatory);
                                form.templateURL = "../modules/hforms/education/views/education_form.html";
                                form.viewTitle = $filter("translate")("Add education");
                                form.formCode = "EDUCATION";
                                form.type = 'job_application';
                                form.load(hUser.getUser().id);
                                break;
                            case 'SKILLS':
                                form = new SkillsForm($scope, registrationApi);
                                form.templateURL = "../modules/hforms/skills/views/skills_form.html";
                                form.viewTitle = $filter("translate")("Add skills");
                                form.formCode = "SKILLS";
                                break;
                            case 'AVAILABILITY':
                                form = new AvailabilityForm($scope);
                                form.templateURL = "../modules/hforms/availability/views/availability_form.html";
                                form.viewTitle = $filter("translate")("When are you available to work?");
                                form.formCode = "AVAILABILITY";
                                break;
                            case 'REFERENCES':
                                form = new ReferencesForm($scope, hUser, 'JOB_APPLY');
                                form.templateURL = "../modules/hforms/references/views/application_references_form.html";
                                form.viewTitle = $filter("translate")("Add references");
                                form.formCode = "REFERENCES";
                                break;
                            case 'USER_VERIFIED_LOCATION':
                                form = new VerifiedLocationForm($scope, $scope.applicationDetails.user_location, googleSearchService, hUser, googleMaps);
                                form.templateURL = "../modules/hforms/verified_location/views/verified_location_form.html";
                                form.formCode = "USER_VERIFIED_LOCATION";
                                break;
                            case 'SCREENING_FORM':
                                var screening_forms = $scope.applicationDetails.screening_forms.filter(function (form) {
                                    return !form.type || form.type !== 'EEO';
                                });

                                $scope.applicationForms[formCode] = [];
                                screening_forms.forEach(function (screening_form) {
                                    form = new ScreeningAnswerForm($scope, screening_form, null, null , 'V2', true, hUser.data.user.id);
                                    form.templateURL = "../modules/hforms/screening_answer/views/screening_answer_form.html";
                                    form.viewTitle = $filter("translate")("Application questions");
                                    $scope.applicationForms[formCode].push(form);
                                    form.type = 'job_application';
                                    form.id = screening_form.id;
                                    form.formCode = "screening_forms";
                                    form.onRemoveJob = onRemoveJob;
                                    form.setJobsName(getJobsName(screening_form.applied_job_ids));
                                    $scope.jobApplicationForms.addForm(form);
                                });
                                break;
                            case 'PROFILE_IMAGE':
                                form = new ProfilePhotoForm($scope);
                                form.templateURL = "../modules/hforms/profile_photo/views/profile_photo_form.html";
                                form.viewTitle = $filter("translate")("Profile photo");
                                form.formCode = "PROFILE_IMAGE";
                                break;
                            case 'E_VERIFY':
                                break;
                            default:
                                console.error("Couldn't find form with code:", formCode);
                        }
                        if (form && formCode !== 'SCREENING_FORM') {
                            if (formCode == 'APPLICATION_DOCUMENT') {
                                $scope.applicationForms["APPLICATION_DOCUMENT" + "_" + formOptions['application_document']['id']] = form;
                            } else {
                                $scope.applicationForms[formCode] = form;
                            }
                            form.type = 'job_application';
                            $scope.jobApplicationForms.addForm(form);
                        }
                    });

                    if ($scope.applicationDetails.eeo_screening_forms && $scope.applicationDetails.eeo_screening_forms.length && $scope.eeoServiceEnabled) {
                        var form = null;
                        $scope.applicationForms['EEO_SCREENING_FORM'] = [];
                        $scope.applicationDetails.eeo_screening_forms.forEach(function (eeo_screening_form) {
                            form = new ScreeningAnswerForm($scope, eeo_screening_form, null, null , 'V2', true, hUser.data.user.id);
                            form.templateURL = "../modules/hforms/screening_answer/views/screening_answer_form.html";
                            form.viewTitle = $filter("translate")("EEO Screening Questions");
                            form.type = 'job_application';
                            form.id = eeo_screening_form.id;
                            form.formCode = "eeo_screening_forms";
                            form.onRemoveJob = onRemoveJob;
                            form.setJobsName(getJobsName(eeo_screening_form.applied_job_ids));
                            $scope.applicationForms['EEO_SCREENING_FORM'].push(form);
                            $scope.eeoScreeningForms.addForm(form);
                        });
                    }

                    if ($scope.applicationDetails.disclaimers && $scope.applicationDetails.disclaimers.length) {
                        var form = null;
                        form = new DisclaimerForm($scope, $scope.applicationDetails.disclaimers);
                        form.templateURL = "../modules/hforms/disclaimer_form/views/disclaimer_form.html";
                        form.viewTitle = $filter("translate")("");
                        form.type = 'job_application';
                        form.formCode = "disclaimer_consent";
                        form.getJobsName = getJobsName;
                        form.onDisclaimerCheckboxChange = onDisclaimerCheckboxChange;
                        $scope.applicationForms['DISCLAIMERS'] = form;
                        $scope.disclaimerForms.addForm(form);
                        form.load();
                    }

                    checkResumeRequirements();
                };

                var checkResumeRequirements = function () {
                    // Add resume, and enable parse if work history or education is required
                    if ($scope.applicationForms['WORK_HISTORY'] || $scope.applicationForms['EDUCATION']) {
                        if (!$scope.applicationForms['RESUME']) {
                            $scope.formsToFill = [{ 'code': 'RESUME', 'is_optional': true }].concat($scope.formsToFill);
                            var form = new ResumeUploadForm($scope, Upload, null, hUser, $scope.selectedJobs, true);
                            form.type = 'job_application';
                            form.setRequired(false);
                            form.templateURL = "../modules/hforms/resume_upload/views/resume_upload_form.html";
                            $scope.applicationForms['RESUME'] = form;
                            $scope.jobApplicationForms.addForm(form);
                        }

                        $scope.applicationForms['RESUME'].allowParse(true);
                    }
                };

                var checkAppRequirements = function () {
                    var deferred = $q.defer();
                    var promises = {};
                    const servicesToCheck = ['E_VERIFY','EEO_REPORT', 'EQUAL_EMPLOYMENT_OPPORTUNITY'];

                    promises['application'] = JobApplicationAPI.getAppsDetails($scope.jobsIds);
                    promises['servicesOnJobs'] = JobApplicationAPI.checkServicesOnJobs($scope.allJobsIds, servicesToCheck);

                    $scope.processing = true;
                    $q.all(promises).then(async (res) => {
                        $scope.existingServices = res["servicesOnJobs"]['existing_services'];
                        $scope.applicationDetails = res["application"];
                        $scope.isEducationDatesMandatory = $scope.applicationDetails.is_education_dates_mandatory;
                        var eeoService = $scope.existingServices.map(function (e) {
                            return (e.code)
                        }).indexOf('EEO_REPORT');
                        $scope.eeoServiceEnabled = (eeoService > -1) ? true : false;
                        var everifyService = $scope.existingServices.map(function (e) {
                            return (e.code)
                        }).indexOf('E_VERIFY');
                        $scope.everifyServiceEnabled = (everifyService > -1) ? true : false;
                        $scope.isEqualEmploymentOpportunityServiceEnabled = $scope.existingServices.map(e => e.code).includes('EQUAL_EMPLOYMENT_OPPORTUNITY');
                        if ($scope.applicationDetails.eeo_screening_forms && $scope.applicationDetails.eeo_screening_forms.length && $scope.eeoServiceEnabled) {
                            let foundEEO = MULIPLE_APPLY_STEPS.find(function (o) {
                                return (o.code === 'EEO_SCREENING_QUESTIONS');
                            });
                            if (!foundEEO){
                                MULIPLE_APPLY_STEPS.push({
                                    code: 'EEO_SCREENING_QUESTIONS',
                                    label: 'EEO Screening Questions',
                                });
                            }
                        }
                        if ($scope.applicationDetails.disclaimers && $scope.applicationDetails.disclaimers.length) {
                            let foundDisclaimers = MULIPLE_APPLY_STEPS.find(function (o) {
                                return (o.code === 'DISCLAIMERS');
                            });
                            if (!foundDisclaimers) {
                                MULIPLE_APPLY_STEPS.push({
                                    code: 'DISCLAIMERS',
                                    label: 'Disclaimers',
                                });
                            }
                        }
                        if ($scope.isEqualEmploymentOpportunityServiceEnabled) {
                            const params = {
                                job_ids: $scope.jobsIds.join(',')
                            };
                            const response = await EEOAPI.getEeoQuestionsCandidateSettings($scope.modalData.brand.id, 'EQUAL_EMPLOYMENT_OPPORTUNITY', params);

                            $scope.eeoForms = response.forms;

                            setTimeout(() => {
                                $scope.$digest();
                            }, 1);
                        }

                        var applicationOptions = $scope.applicationDetails.applications_options;
                        $scope.formsToFill = $scope.formsToFill.concat(applicationOptions);
                        if ($scope.formsToFill.length) {
                            prepareApplicationForms();
                            $scope.processing = false;
                        }
                        deferred.resolve()
                    });

                    return deferred.promise;
                };

                var getJobsName = function (appliedJobIds) {
                    var appliedJobs = $scope.selectedJobs.filter(function (job) {
                        return (appliedJobIds.indexOf(job.id) !== -1);
                    });

                    var jobsNames = [];

                    appliedJobs.forEach(function (job) {
                        var jobPositionObj = {
                            'Position': job.position,
                            'custom_position': job.aliasPosition
                        };
                        var jobName = $filter('userPosition')(jobPositionObj);
                        jobsNames.push(jobName);
                    });

                    if (jobsNames.length) {
                        return (jobsNames.join(','));
                    } else {
                        return (appliedJobIds.join(','));
                    }
                };

                $scope.next = function () {
                    try {
                        var moved = false;
                        $scope.disableApply = false;
                        if ($scope.currentStep === 'SELECT_JOBS') {
                            if ($scope.selectJobsForm.validator.validate()) {
                                $scope.selectJobsForm.save()
                                    .then(function (res) {
                                        $scope.numsOfSelectedJobs = res.numsOfSelectedJobs;
                                        $scope.selectedJobs = res.selectedJobs;
                                        $scope.isJobLocationMassachusetts = $scope.selectedJobs.some(job => job.locations.find(location => location?.state === MASSACHUSETTS_STATE_NAME));
                                        $scope.jobsIds = _.pluck(res.selectedJobs, 'id');
                                        var foundTooFarJobs = $scope.selectedJobs.filter(function (job) {
                                            return (job.tooFar);
                                        });

                                        if (foundTooFarJobs && foundTooFarJobs.length) {
                                            hConfirm({
                                                title: $filter("translate")(""),
                                                text: $filter("translate")(foundTooFarJobs.length + " jobs are very far from where you are located. Are you sure you want to continue?"),
                                                confirmButton: $filter("translate")("Proceed"),
                                                cancelButton: $filter("translate")("Go back"),
                                                callback: function (confirmed) {
                                                    if (confirmed) {
                                                        $scope.currentStep = 'JOBS_APPLICATION';
                                                        $scope.multipleApplyWizardForm.load({
                                                            activeStep: $scope.currentStep,
                                                            steps: $scope.steps
                                                        });
                                                        $scope.formsToFill = [];
                                                        $scope.jobApplicationForms = new FormGroup();
                                                        $scope.eeoScreeningForms = new FormGroup();
                                                        $scope.disclaimerForms = new FormGroup();
                                                        $scope.applicationForms = {};
                                                        checkAppRequirements();
                                                        moved = true;
                                                    }
                                                }
                                            });
                                        } else {
                                            $scope.currentStep = 'JOBS_APPLICATION';
                                            $scope.multipleApplyWizardForm.load({
                                                activeStep: $scope.currentStep,
                                                steps: $scope.steps
                                            });
                                            $scope.formsToFill = [];
                                            $scope.jobApplicationForms = new FormGroup();
                                            $scope.eeoScreeningForms = new FormGroup();
                                            $scope.disclaimerForms = new FormGroup();
                                            $scope.applicationForms = {};
                                            checkAppRequirements();
                                            moved = true;
                                        }

                                        setTimeout(function () {
                                            $scope.$digest();
                                        }, 1);
                                    })
                                    .catch(function (err) {
                                        console.error(err, "err");

                                        setTimeout(function () {
                                            $scope.$digest();
                                        }, 1);
                                    });
                            }
                        }
                        else if ($scope.currentStep === 'JOBS_APPLICATION'){
                            if ($scope.jobApplicationForms.validateAll()) {
                                if ($scope.applicationDetails.eeo_screening_forms && $scope.eeoServiceEnabled) {
                                    $scope.currentStep = 'EEO_SCREENING_QUESTIONS';
                                } else if ($scope.applicationDetails.disclaimers) {
                                    $scope.currentStep = 'DISCLAIMERS';
                                }

                                $scope.multipleApplyWizardForm.load({
                                    activeStep: $scope.currentStep,
                                    steps: $scope.steps
                                });
                                moved = true;
                            }
                        }
                        else if ($scope.currentStep === 'EEO_SCREENING_QUESTIONS'){
                            if ($scope.eeoScreeningForms.validateAll()) {
                                if ($scope.applicationDetails.disclaimers) {
                                    $scope.currentStep = 'DISCLAIMERS';
                                    $scope.disableApply = true;
                                }

                                $scope.multipleApplyWizardForm.load({
                                    activeStep: $scope.currentStep,
                                    steps: $scope.steps
                                });
                                moved = true;
                            }
                        }

                        if (!moved && $scope.currentStep === $scope.steps[$scope.steps.length - 1].code) {
                            $scope.save();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };

                $scope.back = function () {
                    try {
                        $scope.disableApply = false;
                        if ($scope.currentStep === 'JOBS_APPLICATION') {
                            $scope.currentStep = 'SELECT_JOBS';
                            $scope.multipleApplyWizardForm.load({activeStep: $scope.currentStep, steps: $scope.steps});
                        }
                        if ($scope.currentStep === 'EEO_SCREENING_QUESTIONS') {
                            $scope.currentStep = 'JOBS_APPLICATION';
                            $scope.multipleApplyWizardForm.load({activeStep: $scope.currentStep, steps: $scope.steps});
                        }
                        if ($scope.currentStep === 'DISCLAIMERS') {
                            $scope.currentStep = ($scope.eeoServiceEnabled) ?  'EEO_SCREENING_QUESTIONS' : 'JOBS_APPLICATION';
                            $scope.multipleApplyWizardForm.load({activeStep: $scope.currentStep, steps: $scope.steps});
                        }
                    } catch (e) {
                        console.error(e);
                    }
                };

                $scope.apply = async () => {
                    if (($scope.currentStep === 'JOBS_APPLICATION'
                            && !$scope.applicationDetails.disclaimers
                            && !$scope.applicationDetails.eeo_screening_forms)
                        || ($scope.currentStep === 'EEO_SCREENING_QUESTIONS'
                            && !$scope.applicationDetails.disclaimers)
                        || ($scope.currentStep === 'DISCLAIMERS')) {
                        var promises = [];
                        if ($scope.jobApplicationForms.validateAll() &&
                            $scope.eeoScreeningForms.validateAll() &&
                            $scope.disclaimerForms.validateAll()) {
                            var payload = {};
                            var allForms = [];
                            allForms = allForms.concat($scope.jobApplicationForms.getForms(), $scope.eeoScreeningForms.getForms(), $scope.disclaimerForms.getForms());
                            payload["job_ids"] = $scope.jobsIds;
                            if ($scope.modalData.talentScoutId) {
                                payload['talent_scout_code_id'] = parseInt($scope.modalData.talentScoutId);
                            }
                            payload["screening_forms"] = [];
                            payload["eeo_screening_forms"] = [];
                            allForms.forEach(function (form) {
                                if (form) {
                                    if (form.formCode != 'resume_url'
                                        && form.formCode != 'availability_matrix'
                                        && form.formCode != 'JOB_APPLY_DISCLAIMER'
                                        && form.formCode != 'work_eligibility'
                                        && form.formCode != 'screening_forms'
                                        && form.formCode != 'disclaimer_consent'
                                        && form.formCode != 'eeo_screening_forms') {
                                        promises.push(form.save());
                                    } else {
                                        if (form.formCode != 'screening_forms' && form.formCode != 'eeo_screening_forms') {
                                            payload[form.formCode] = form.getPreparedData();
                                        } else {
                                            var data = form.getPreparedData();
                                            if (data.questions && data.questions.length) {
                                                payload[form.formCode].push(form.getPreparedData());
                                            }
                                        }
                                    }
                                }
                            });
                            if (!payload["screening_forms"].length) {
                                delete payload["screening_forms"];
                            }
                            if (!payload["eeo_screening_forms"].length) {
                                delete payload["eeo_screening_forms"];
                            }
                            $scope.saving = true;
                            try {
                                await jobApplyFactory.getCandidateApplyStatus($scope.modalData.brand.id);
                            } catch (error) {
                                if (error?.code === jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR) {
                                    hAlert(
                                        $filter("translate")("Error"),
                                        jobApplyFactory.handleApplicationFlowLocalizationErrorMessage(error.data),
                                        () => {
                                            $scope.$hide();
                                            $scope.saving = false;
                                        }
                                    );
                                    return;
                                }
                            }
                            $q.all(promises)
                                .then(function (data) {
                                    JobApplicationAPI.bulkApply(payload)
                                        .then(function (res) {
                                            $scope.$hide();
                                            $scope.saving = false;
                                            $scope.modalData.onApplySuccess($scope.jobsIds, null, true);
                                            if ($scope.isEqualEmploymentOpportunityServiceEnabled && $scope.eeoForms.length) {
                                                $state.go("BulkApplyScreening", {
                                                    brand_id: $scope.modalData.brand.id,
                                                    job_id: $scope.jobsIds.join(','),
                                                    form_type: "EQUAL_EMPLOYMENT_OPPORTUNITY"
                                                });
                                            }
                                            setTimeout(function () {
                                                $scope.$digest();
                                            }, 1);
                                        }).catch(function (err) {
                                        $scope.saving = false;
                                        console.error(err);
                                        $scope.showApplyWarningModal();
                                    });
                                }).catch(function (err) {
                                $scope.saving = false;
                                console.error(err);
                                $scope.showApplyWarningModal();
                            });
                        }
                    } else {
                        $scope.next();
                    }
                };

                $scope.save = function () {
                    $scope.$hide();
                };

                $scope.showApplyWarningModal = function () {
                    $modal({
                        controller: 'applyWarningModal',
                        templateUrl: '../modules/profiles/modals/apply-warning/apply-warning.modal.html',
                        show: true,
                        resolve: {
                            modalData: function () {
                                return {};
                            },
                            onSave: function () {
                                return function () {
                                    $scope.apply();
                                };
                            },
                            onClose: function () {
                                return function () {
                                    $scope.$hide();
                                };
                            }
                        }
                    });
                };

                //Hide modal
                $scope.close = function () {
                    $scope.$hide();
                };
            }]);
})(angular);
